__turbopack_context__.v({
  "disabled": "YBhCjG_disabled",
  "input": "YBhCjG_input",
  "switch": "YBhCjG_switch",
  "thumb": "YBhCjG_thumb",
  "thumbChecked": "YBhCjG_thumbChecked",
  "thumbDisabled": "YBhCjG_thumbDisabled",
  "track": "YBhCjG_track",
  "trackDisabled": "YBhCjG_trackDisabled",
  "trackPrimaryChecked": "YBhCjG_trackPrimaryChecked",
  "trackSecondaryChecked": "YBhCjG_trackSecondaryChecked",
});
